<dx-switch [disabled]="disabled" [(value)]="value" width="auto"
  switchedOnText="{{ switchOnLabel | transloco }}" switchedOffText="{{ switchOffLabel | transloco }}"
  (valueChange)="onSelfChangeValue(value);"
  (onFocusIn)="(!!onFocusIn && onFocusIn())"
  (onFocusOut)="(!!onFocusOut && onFocusOut())"> </dx-switch>